import { React, useState, useEffect } from 'react';
import GeoGebraMySol from '../components/GeoGebraMySol';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
// import '../App.css';
import ViewMyAnswerItem from '../components/ViewMyAnswerItem';

const DoorProblemMy = ()=> {
    const navigateto=useNavigate();
    const {doorProbIDMy}=useParams();
    const {problemURL, problemInfo, myAnswerList} = useLocation().state;
    const {myConstructionStep, myAnswerRaw, myPointConstruction, errAns} = ViewMyAnswerItem({"answerMark": doorProbIDMy});
    const location = useLocation();
    const [selectedAnswer, setSelectedAnswer] = useState();
    const [randomString1, setRandomString1] = useState();
    const [myConstruct, setMyConstruct] = useState('');
    const [flag, setFlag] =useState('');

    useEffect(() => {
        setMyConstruct(myConstructionStep);
        setFlag(doorProbIDMy);
    },[myConstructionStep])

    useEffect(() => {
        const revivalData = () => {
            const letters = '1234567890';
            let randomString1l = '';
            for (let i = 0; i < 3; i++) {
                randomString1l += letters[Math.floor(Math.random() * letters.length)];
            }
            setRandomString1(randomString1l);
          };
          revivalData();
    },[doorProbIDMy])

    return(
        <div className="problem" key={myAnswerRaw.answerMark}>
            {errAns 
                ? navigateto("/login", {state:{"from": location}}, {replace: true})
                : <div className="content-fit">
                    <h4>{myAnswerRaw && `${myAnswerRaw.solvingTime.substring(6,10)}년 ${myAnswerRaw.solvingTime.substring(3,5)}월 ${myAnswerRaw.solvingTime.substring(0,2)}일 ${myAnswerRaw.solvingTime.substring(12,17)}의 풀이`}</h4>
                    <div>
                        <select value={selectedAnswer} style={{height:"36px"}} onChange={(e) => setSelectedAnswer(e.target.value)}>
                            <option value>문제를 푼 때를 선택하세요.</option>
                            {myAnswerList.map(myAns => {
                                return <option value={myAns.answerMark} key={myAns.answerMark}>
                                    {myAns.solvingTime.substring(6,10)}년 {myAns.solvingTime.substring(3,5)}월 {myAns.solvingTime.substring(0,2)}일 {myAns.solvingTime.substring(12,17)}
                                </option>
                            })}
                        </select>
                        <button 
                            className='button' 
                            style={{marginLeft:"10px"}}
                            onClick={() => navigateto(`/door/problem/my/${selectedAnswer}`, {state: {
                                "problemURL": problemURL,
                                "problemInfo": problemInfo,
                                "myAnswerList": myAnswerList
                            }})}
                        >
                            풀이 보기
                        </button>
                    </div>
                    <div key={flag}>
                        {myConstruct.length !== 0
                            ? <GeoGebraMySol
                                    idIn={problemInfo.problemCode}
                                    customToolBarIn={problemInfo.customToolBar}
                                    allowStyleBarIn={problemInfo.allowStyleBar}
                                    ggbBase64In={problemInfo.problemContent}
                                    myPointAnswer={myPointConstruction}
                                    myAnswerStep={myConstruct}
                                    problemType={problemInfo.problemType}
                                />
                            : "Loading"
                        }
                    </div>
                    <div className='horizontal-flex-container'>
                        <button 
                            className='button'
                            onClick={() => navigateto(`/door/problem/${problemURL}`)}
                        >
                            문제로 돌아가기
                        </button>
                        {(problemInfo.problemType === 1 || problemInfo.problemType === 2)
                            ? <button 
                                    className='button'
                                    onClick={() => navigateto(`/door/problem/my/animation/${doorProbIDMy}`, {state:{
                                        "problemURL": problemURL,
                                        "problemInfo": problemInfo,
                                        "myAnswerList": myAnswerList,
                                        "doorProbIDMy": doorProbIDMy,
                                        "myConstructionStep": myConstructionStep,
                                        "myPointConstruction": myPointConstruction,
                                        "myAnswerRaw":myAnswerRaw
                                    }})}
                                >
                                    풀이 과정 보기
                                </button>
                            : null
                        }
                    </div>
                </div>
            }
            <br/>
        </div>
    );
};

export default DoorProblemMy;
